<template>
  <div v-if="selectedInitiative.initiatiefId > 0" id="Gegevens">
    <div class="container gegevens">
      <section class="row">
        <div class="col-xs-12 col-xl-8 col-xl-offset-2 col-lg-10 col-lg-offset-1">
          <div class="content">
            <a href="index.html" class="backlink">{{labels.LINK_VORIGE_PAGINA}}</a>
          </div>
        </div>
      </section>
      <article>
        <div class="row">
          <div class="col-xl-8 col-xl-offset-2 col-lg-10 col-lg-offset-1">
            <div class="content-background">
              
              <div class="content">

                <div v-if="submissionPossible() && submissionDeadlinePassed()" class="notification notification--warning">
                  <div class="notification__content">
                    <strong class="notification__title">{{ labels.INITIATIEF_DEADLINE_VERSTREKEN_TITEL }}</strong>
                    <p>{{ labels.INITIATIEF_DEADLINE_VERSTREKEN_TEKST }}</p>
                  </div>
                </div>

                <div v-else-if="toonInfoLabel" :class="toonOuderverklaring(selectedInitiative).class">
                  <div id="niet_steun" class="notification__content">
                    <strong class="notification__title">{{ toonOuderverklaring(selectedInitiative).titel }}</strong>
                    <p>{{ toonOuderverklaring(selectedInitiative).tekst }}</p>
                    <span v-if="toonLinkStatusoverzicht1(selectedInitiative)">
                      <a role="button" tabindex="0" class="link" @click="openModal()">{{labels.BEKIJK_BESLISSING}}</a>
                    </span>
                  </div>
                </div>

                <h1>{{ selectedInitiative.naam }}</h1>
                <span
                  class="label"
                  v-bind:class="[
                  selectedInitiative.sector === 'PO' ? 'label--geel' : 'label--hemelblauw']"
                >
                  {{ toonSoort(selectedInitiative.sector) }}
                </span>
                <span v-for="soortOnderwijs in selectedInitiative.soortOnderwijs"
                  v-bind:key="soortOnderwijs.indicatieId" >
                  <span v-if="!soortOnderwijs.ingetrokken" class="label">
                    {{ toonOpleiding(soortOnderwijs.soortOnderwijs) }}
                  </span>
                  <span v-if="soortOnderwijs.ingetrokken">
                    <span class="label label--line-through">{{ toonOpleiding(soortOnderwijs.soortOnderwijs) }}</span>
                    <button x-uno-tooltip="" class="icon icon-info" v-bind:title="labels.TOOLTIP"></button>
                  </span>
                </span>
                <div class="metas">
                  <span class="meta" v-if="selectedInitiative.keuzePO || selectedInitiative.keuzeVO">
                    <b>
                      <svg class="icon-detail" version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                        y="0px" width="64px" height="64px" viewBox="0 0 64 64" xml:space="preserve">
                        <g id="_x36_4px_Boxes">
                          <rect fill="none" width="64" height="64" />
                        </g>
                        <g id="Production">
                          <g>
                            <path
                              d="M57.4434,23.2119L46.5977,7.8467C46.2227,7.3159,45.6133,7,44.9639,7H19.0361c-0.6494,0-1.2588,0.3159-1.6338,0.8467
                      L6.5566,23.2119C6.3228,23.543,6.5596,24,6.9648,24h7.0767L30,11c1.1613-0.9678,2.7742-0.9355,4,0l15.958,13h7.0772
                      C57.4404,24,57.6772,23.543,57.4434,23.2119z" />
                            <path
                              d="M32,13.6797L15.5308,27H10v29h44V27h-5.5308L32,13.6797z M25,50h-8v-5h8V50z M25,42h-8v-9h8V42z M36,50h-8v-5h8V50z
                      M36,42h-8v-9h8V42z M32,28.2c-2.3195,0-4.2-1.8806-4.2-4.2c0-2.3195,1.8805-4.2,4.2-4.2c2.3195,0,4.2,1.8805,4.2,4.2
                      C36.2,26.3194,34.3195,28.2,32,28.2z M47,50h-8v-5h8V50z M47,42h-8v-9h8V42z" />
                          </g>
                        </g>
                      </svg>
                      <span v-if="selectedInitiative.keuzePO"> {{ toonUitbreidingssoortPo(selectedInitiative.keuzePO) }}</span>
                      <span v-if="selectedInitiative.keuzeVO"> {{ toonUitbreidingssoortVo(selectedInitiative.keuzeVO) }}</span>
                    </b> 
                  </span>

                  <span class="meta"  v-if="selectedInitiative.postcodeCijfers || selectedInitiative.plaatsnaam">
                    <b>
                      <svg class="icon-detail" data-name="Laag 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.62 101.3"><defs></defs><title>Pointer</title><path class="cls-1" d="M32.53.05A27.84,27.84,0,0,0,17.79,3.48C1.71,12-4.52,30.15,3.48,47.42S20.17,81.34,28.57,98.28c.86,1.75,2,3,4.23,3,2.74,0,3.68-1.91,4.66-3.85C44.58,83.32,51.73,69.2,58.77,55c3.49-7,6.84-14.19,6.85-22.22C65.62,13.75,49.88-.55,32.53.05Z"/><path d="M32.53.05c17.35-.6,33.09,13.7,33.09,32.76,0,8-3.36,15.2-6.85,22.22-7,14.17-14.19,28.29-21.31,42.42-1,1.94-1.92,3.87-4.66,3.85-2.24,0-3.37-1.27-4.23-3C20.17,81.34,11.43,64.56,3.48,47.42S1.71,12,17.79,3.48A27.84,27.84,0,0,1,32.53.05Zm.15,52A19.37,19.37,0,1,0,13.43,32.85,19.19,19.19,0,0,0,32.68,52.06Z"/><path class="cls-1" d="M32.68,52.06a19.37,19.37,0,1,1,19.46-19A19.21,19.21,0,0,1,32.68,52.06Zm-.25-11c5,.11,8.64-3.19,8.81-7.93.17-5.07-3.22-8.87-8.07-9a8.32,8.32,0,0,0-8.86,8.29A8.27,8.27,0,0,0,32.43,41Z"/><path d="M32.43,41a8.27,8.27,0,0,1-8.12-8.68,8.32,8.32,0,0,1,8.86-8.29c4.85.17,8.24,4,8.07,9C41.07,37.85,37.4,41.15,32.43,41Z"/></svg>
                      {{ selectedInitiative.postcodeCijfers }} {{ selectedInitiative.plaatsnaam }}</b></span>

                  <span class="meta">
                    <b>
                      <svg class="icon-detail" version="1.2" baseProfile="tiny" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
                        y="0px" width="64px" height="64px" viewBox="0 0 64 64" xml:space="preserve">
                        <g id="_x36_4px_Boxes">
                          <rect fill="none" width="64" height="64"/>
                        </g>
                        <g id="Production">
                          <g>
                            <path d="M57.4434,23.2119L46.5977,7.8467C46.2227,7.3159,45.6133,7,44.9639,7H19.0361c-0.6494,0-1.2588,0.3159-1.6338,0.8467
                      L6.5566,23.2119C6.3228,23.543,6.5596,24,6.9648,24h7.0767L30,11c1.1613-0.9678,2.7742-0.9355,4,0l15.958,13h7.0772
                      C57.4404,24,57.6772,23.543,57.4434,23.2119z"/>
                            <path d="M32,13.6797L15.5308,27H10v29h44V27h-5.5308L32,13.6797z M25,50h-8v-5h8V50z M25,42h-8v-9h8V42z M36,50h-8v-5h8V50z
                      M36,42h-8v-9h8V42z M32,28.2c-2.3195,0-4.2-1.8806-4.2-4.2c0-2.3195,1.8805-4.2,4.2-4.2c2.3195,0,4.2,1.8805,4.2,4.2
                      C36.2,26.3194,34.3195,28.2,32,28.2z M47,50h-8v-5h8V50z M47,42h-8v-9h8V42z"/>
                          </g>
                        </g>
                      </svg>
                      {{ toonRichting(selectedInitiative.richting) }}
                    </b>
                  </span>
                </div>

                <div v-if="toonProfielen" class="collapse" role="status">
                  <div tabindex="0" x-uno-collapse="" aria-expanded="false" class='collapse__header' aria-controls="profiel" role="button" >
                    <i class="collapse__indicator">
                      <span class="screenreader-only" data-contracted-i18n="ingeklapt" data-expanded-i18n="uitgeklapt"></span>
                    </i>
                    <span class="collapse__title">{{ labels.PROFIELEN }} </span><span v-if="profielGewijzigd" class="label label--rood">Gewijzigd</span>
                  </div>
                  <div id="profiel" aria-expanded="false" class='collapse__details collapse__details--indented' >
                    <ul class="columns">
                      <li
                        tabindex="-1"
                        v-for="profiel in selectedInitiative.soortOnderwijs[setIndex].vboProfiel"
                        v-bind:class="profiel.ingetrokken ? 'doorhalen' : ''"
                        v-bind:key="profiel.profiel">
                        <span v-if="!profiel.ingetrokken">{{ toonProfiel(profiel.profiel) }}</span>
                        <span v-if="profiel.ingetrokken">
                          {{ toonProfiel(profiel.profiel) }}
                          <button x-uno-tooltip="" class="icon icon-info" 
                          v-bind:title="labels.TOOLTIP_EXTRA_INFORMATIE_SOORT_ONDERWIJS_INGETROKKEN">
                          </button>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="infoblok">
                  <span class="meta"><b>Bron: {{ labels.BRONVERMELDING }}</b></span>
                  
                  <p v-if="this.leesToggle" id="toelichting" v-html="introTekst(selectedInitiative.toelichting)"></p>

                  <div v-if="countWordsInText(selectedInitiative.toelichting) > 30">
                    <button class="btn btn--link btn--show-more" v-if="this.leesToggle" @click="leesMeer('toelichting')">
                      <svg class="btn__icon btn__icon-blue" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px"
                        height="24px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
                        <g id="icon">
                          <path d="M23.1,5.7L23.1,5.7c-1-1-2.3-1.4-3.3-0.3L12,13.1L4.3,5.3c-1-1-2.3-0.7-3.3,0.3l0,0c-1,1-1.4,2.3-0.3,3.3l9.6,9.6
                            c1,1,2.6,1,3.6,0L23.4,9C24.4,8,24.1,6.7,23.1,5.7z"/>
                        </g>
                      </svg>
                      Lees meer
                    </button>
                  </div>

                  <p v-if="!this.leesToggle" id="toelichtingVol" v-html="selectedInitiative.toelichting"></p>

					        <div v-if="countWordsInText(selectedInitiative.toelichting) > 30">
                    <button  class="btn btn--link btn--show-more" v-if="!this.leesToggle" @click="leesMeer('toelichtingVol')">
                      <svg class="btn__icon btn__icon-blue" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px"
                        height="24px" viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
                        <g id="icon">
                          <path d="M0.9,18.3L0.9,18.3c1,1,2.3,1.4,3.3,0.3l7.7-7.7l7.7,7.7c1,1,2.3,0.7,3.3-0.3l0,0c1-1,1.4-2.3,0.3-3.3l-9.6-9.6
                            c-1-1-2.6-1-3.6,0L0.6,15C-0.4,16-0.1,17.3,0.9,18.3z"/>
                        </g>
                      </svg>
                      Lees minder
                    </button>
                  </div>
				        </div>

                <span class="is-h4">{{ labels.SUB_TITEL_CONTACTGEGEVENS }}</span>
                <p v-if="geenContactgegevens">
                  {{ selectedInitiative.rechtspersoonNaam }} <br v-if="selectedInitiative.rechtspersoonNaam" />
                  {{ selectedInitiative.telefoonnummer }} <br v-if="selectedInitiative.telefoonnummer" />
                  {{ selectedInitiative.emailadres }} <br v-if="selectedInitiative.emailadres" />
                  <a v-bind:href="formatWebsiteUrl(selectedInitiative.website)">{{ formatWebsiteUrl(selectedInitiative.website) }}</a>
                </p>
                <p v-if="!geenContactgegevens"> {{labels.GEEN_GEGEVENS_GEVONDEN}} </p>

                  <div v-if="submissionPossible() && !submissionDeadlinePassed()"
                    :class="toonOuderverklaring(selectedInitiative, 'detail').class"
                  >
                    <div id="steun" class="notification__content">
                      <strong class="notification__title">{{toonOuderverklaring(selectedInitiative, 'detail').titel}}</strong>
                      <p v-html="toonOuderverklaring(selectedInitiative, 'detail').tekst"></p>
                      <button
                        class="btn btn--primary btn--digid cta-link"
                        @click="verzend(selectedInitiative)"
                      >
                        {{ labels.BUTTON_OUDERVERKLARING }}
                        <span class="screenreader-only">&nbsp;met DigiD</span>
                      </button>
                    </div>
                  </div>

              </div>
            </div>
          </div>
        </div>
      </article>
    </div>
    <div><ModalComponent /></div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {toonDescription} from "../mixins/toonDescription";
import {steunInitiatief} from "../mixins/steunInitiatief";
import ModalComponent from "../components/Modal";

export default {
  name: "Gegevens",
  data() {
    return {
      selectedInitiatief: [],
      leesToggle: true
    };
  },
  components:{
    ModalComponent
  },

   created() {


    this.$trackPageView('Initiatief : ' + this.$route.params.id);


    if (window.System) {
      window.System.import('./libs/uno/dist/components/collapse/collapse.min.js').then((module) => {
        // Select all collapsible elements on the page
      var collapses = document.querySelectorAll('[x-uno-collapse]');
        // Initialize all collapses
        for (var i = 0; i < collapses.length; i++) {
          new module.Collapse(collapses.item(i));
        }
      });

      window.System.import('./libs/uno/dist/components/tooltip/tooltip.js')
      .then(module => {
        var tooltips = document.querySelectorAll('.icon-info');
        for (var i = 0; i < tooltips.length; i++) {
           new module.Tooltip(tooltips.item(i));
        }
      });
    }
  },
  
  methods: {
    getInitiatieven() {
      if(this.initiatives.length == 0) {
        this.$store.dispatch('FETCH_INITIATIVES')
      }
    },

    selectGegevens() {
      var initiatiefId = this.$route.params.id;
      this.selectedInitiatief = this.initiatives.find(
        initiatief => initiatief.initiatiefId === initiatiefId
        );
  	  if(!this.selectedInitiatief) {
        this.$router.push({ path: '/404/initiatief=' + this.$route.params.id })
      }
      else {
        var parsedObj = JSON.parse(JSON.stringify(this.selectedInitiatief));
        this.$store.dispatch('SELECT_INITIATIVE', parsedObj);
      }
    },
    
    openModal() {
      if (this.$matomo) {
        this.$matomo.trackEvent("Initiatief-scholen", "bekijkbeslissing", this.selectedInitiative.naam);
      }
      this.modal.open();
    },

    submissionDeadlinePassed: function() {

      let today = new Date();
      let deadline = new Date(today.getFullYear(), 9, 30);

      if(today.getFullYear() === 2021) {
        deadline.setDate(30);
      }
      return deadline <= today;
    },

    submissionPossible: function() {
      let toonOuderverklaring = this.selectedInitiative.StatusExtern.statusExtern.toLowerCase() != "ingetrokken" &&
        (this.selectedInitiative.datumtijdAanvraagIngediend == undefined || this.selectedInitiative.datumtijdAanvraagIngediend == "") &&
        this.selectedInitiative.belangstellingsmetingOuderverklaring;
      return toonOuderverklaring;
    },
    leesMeer: function(element){
      var x = document.getElementById(element);
      if (x.style.display === "none") {
        x.style.display = "block";
      }
      this.leesToggle = (element == "toelichting") ? false : true;
      return this.leesToggle
    },
    formatWebsiteUrl(url) {
      if (url) {
        if (url.search(/^http[s]?\:\/\//) == -1) {
          url = 'https://' + url;
        }
      return url;
      }
    }
  },

  mounted() {
    this.getInitiatieven();

    if (window.System) {
      window.System.import('./libs/uno/dist/components/modal/modal.min.js').then((module) => {
        this.modal = new module.Modal(document.getElementById('myModal'));
      });
    }
  },
  mixins: [toonDescription, steunInitiatief],
  watch: {
    initiatives: function(val){
      this.selectGegevens();
    },
    '$route': function(to, from) {
      this.selectGegevens();
    }
  },
  computed: {
    ...mapGetters(["selectedInitiative", "selectedId", "labels", "initiatives" ]),
    toonProfielen: function(){
      return typeof(this.selectedInitiative.soortOnderwijs[this.setIndex]) != 'undefined' &&
      this.selectedInitiative.soortOnderwijs[this.setIndex].vboProfiel.length > 0  ? true : false;
    },
    geenContactgegevens: function () {
      var gegevens = true;
      if (!this.selectedInitiative.rechtspersoonNaam &&
        !this.selectedInitiative.emailadres &&
        !this.selectedInitiative.website &&
        !this.selectedInitiative.telefoonnummer) {
        gegevens = false;
      }
      return gegevens;
    },
    toonInfoLabel: function() {
      return this.selectedInitiative.belangstellingsmetingMarktonderzoek ||
      this.selectedInitiative.StatusExtern.statusExtern.toLowerCase() != 'gepubliceerd' ||
      this.selectedInitiative.keuzePO ||
      this.selectedInitiative.keuzeVO;
    },
    setIndex: function () {
      var index = 0;
      for (var i = 0; i < this.selectedInitiative.soortOnderwijs.length; i++) {
        if (this.selectedInitiative.soortOnderwijs[i].soortOnderwijs === "VBO") {
          index = i;
        }
      }
      return index;
    },
    profielGewijzigd: function() {
      for (var i=0;i < this.selectedInitiative.soortOnderwijs[this.setIndex].vboProfiel.length; i++){
        return this.selectedInitiative.soortOnderwijs[this.setIndex].vboProfiel[i].ingetrokken;
      }
      return false;
    }
  }
}
</script>
